import { Container } from "inversify";
import {
  CategoriesRepository,
  ColorsRepository,
  ConfigRepository,
  DiscountRepository,
  OrdersRepository,
  ProductsRepository,
  UserRepository,
} from "./domain";
import { HomeRepository } from "./domain/repositories/home-repository";
import {
  createHttpClinet,
  HttpClient,
  CategoriesRemoteDataSource,
  ConfigRemoteDataSource,
  DiscountRemoteDataSource,
  DiscountRepositoryImpl,
  OrdersRemoteDataSource,
  ProductsRemoteDataSource,
  ProductsRepositoryImpl,
  UserRemoteDataSource,
  UserRepositoryImpl,
  UserLocalDataSource,
  OrdersRepositoryImpl,
  CategoriesRepositoryImpl,
  ConfigRepositoryImpl,
  HomeRemoteDataSource,
  HomeRepositoryImpl,
  ColorsRemoteDataSource,
  ColorsRepositoryImpl,
} from "./infrastructure";

const Services = {
  HttpClinet: Symbol.for("HttpClinet"),

  // data sources
  CategoriesRemoteDataSource: Symbol.for("CategoriesRemoteDataSource"),
  ColorsRemoteDataSource: Symbol.for("ColorsRemoteDataSource"),
  ConfigRemoteDataSource: Symbol.for("ConfigRemoteDataSource"),
  DiscountRemoteDataSource: Symbol.for("DiscountRemoteDataSource"),
  HomeRemoteDataSource: Symbol.for("HomeRemoteDataSource"),
  OrdersRemoteDataSource: Symbol.for("OrdersRemoteDataSource"),
  ProductsRemoteDataSource: Symbol.for("ProductsRemoteDataSource"),
  UserLocalDataSource: Symbol.for("UserLocalDataSource"),
  UserRemoteDataSource: Symbol.for("UserRemoteDataSource"),

  // repositories
  CategoriesRepository: Symbol.for("CategoriesRepository"),
  ColorsRepository: Symbol.for("ColorsRepository"),
  ConfigRepository: Symbol.for("ConfigRepository"),
  DiscountRepository: Symbol.for("DiscountRepository"),
  HomeRepository: Symbol.for("HomeRepository"),
  OrdersRepository: Symbol.for("OrdersRepository"),
  ProductsRepository: Symbol.for("ProductsRepository"),
  UserRepository: Symbol.for("UserRepository"),
};

const ServiceLocater = new Container();

const httpClient = createHttpClinet();
ServiceLocater.bind<HttpClient>(Services.HttpClinet).toConstantValue(
  httpClient
);

// data sources
ServiceLocater.bind<ProductsRemoteDataSource>(
  Services.ProductsRemoteDataSource
).toConstantValue(new ProductsRemoteDataSource(httpClient));

ServiceLocater.bind<UserRemoteDataSource>(
  Services.UserRemoteDataSource
).toConstantValue(new UserRemoteDataSource(httpClient));

ServiceLocater.bind<UserLocalDataSource>(
  Services.UserLocalDataSource
).toConstantValue(new UserLocalDataSource());

ServiceLocater.bind<DiscountRemoteDataSource>(
  Services.DiscountRemoteDataSource
).toConstantValue(new DiscountRemoteDataSource(httpClient));

ServiceLocater.bind<CategoriesRemoteDataSource>(
  Services.CategoriesRemoteDataSource
).toConstantValue(new CategoriesRemoteDataSource(httpClient));

ServiceLocater.bind<HomeRemoteDataSource>(
  Services.HomeRemoteDataSource
).toConstantValue(new HomeRemoteDataSource(httpClient));

ServiceLocater.bind<OrdersRemoteDataSource>(
  Services.OrdersRemoteDataSource
).toConstantValue(new OrdersRemoteDataSource(httpClient));

ServiceLocater.bind<ConfigRemoteDataSource>(
  Services.ConfigRemoteDataSource
).toConstantValue(new ConfigRemoteDataSource(httpClient));

ServiceLocater.bind<ColorsRemoteDataSource>(
  Services.ColorsRemoteDataSource
).toConstantValue(new ColorsRemoteDataSource(httpClient));

// repositories
ServiceLocater.bind<CategoriesRepository>(
  Services.CategoriesRepository
).toConstantValue(
  new CategoriesRepositoryImpl(
    ServiceLocater.get<CategoriesRemoteDataSource>(
      Services.CategoriesRemoteDataSource
    )
  )
);

ServiceLocater.bind<ColorsRepository>(
  Services.ColorsRepository
).toConstantValue(
  new ColorsRepositoryImpl(
    ServiceLocater.get<ColorsRemoteDataSource>(Services.ColorsRemoteDataSource)
  )
);

ServiceLocater.bind<ConfigRepository>(
  Services.ConfigRepository
).toConstantValue(
  new ConfigRepositoryImpl(
    ServiceLocater.get<ConfigRemoteDataSource>(Services.ConfigRemoteDataSource)
  )
);

ServiceLocater.bind<DiscountRepository>(
  Services.DiscountRepository
).toConstantValue(
  new DiscountRepositoryImpl(
    ServiceLocater.get<DiscountRemoteDataSource>(
      Services.DiscountRemoteDataSource
    )
  )
);

ServiceLocater.bind<HomeRepository>(Services.HomeRepository).toConstantValue(
  new HomeRepositoryImpl(
    ServiceLocater.get<HomeRemoteDataSource>(Services.HomeRemoteDataSource)
  )
);

ServiceLocater.bind<OrdersRepository>(
  Services.OrdersRepository
).toConstantValue(
  new OrdersRepositoryImpl(
    ServiceLocater.get<OrdersRemoteDataSource>(Services.OrdersRemoteDataSource)
  )
);

ServiceLocater.bind<ProductsRepository>(
  Services.ProductsRepository
).toConstantValue(
  new ProductsRepositoryImpl(
    ServiceLocater.get<ProductsRemoteDataSource>(
      Services.ProductsRemoteDataSource
    )
  )
);

ServiceLocater.bind<UserRepository>(Services.UserRepository).toConstantValue(
  new UserRepositoryImpl(
    ServiceLocater.get<UserRemoteDataSource>(Services.UserRemoteDataSource),
    ServiceLocater.get<UserLocalDataSource>(Services.UserLocalDataSource)
  )
);

export { ServiceLocater, Services };
